function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "plus-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.5001 6.6665V13.3332M7.16675 9.99984H13.8334M18.8334 9.99984C18.8334 14.6022 15.1025 18.3332 10.5001 18.3332C5.89771 18.3332 2.16675 14.6022 2.16675 9.99984C2.16675 5.39746 5.89771 1.6665 10.5001 1.6665C15.1025 1.6665 18.8334 5.39746 18.8334 9.99984Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus_circle.47c712d0467f271c000eda6c65d61c7c.svg";
export { ForwardRef as ReactComponent };